import {usePurchaseStartCallback} from '@/hooks/purchase';
import {getOnKeyDownProp} from '@/lib/utils/a11y';
import {useEmitEventOnClick} from '@/lib/utils/analytics';
import {AnalyticEventProps} from '@/types';
import {Card, CardProps} from '@eds-web/react';
import {CatalogOffer} from 'epic-graphql-types';
import {SyntheticEvent} from 'react';

interface CatalogCheckoutOfferCardProps {
	cardProps: CardProps;
	offer: CatalogOffer;
	analytics?: AnalyticEventProps;
	locale: string;
}

export const CatalogCheckoutOfferCard = (props: CatalogCheckoutOfferCardProps) => {
	const {id, namespace} = props.offer || {};
	const {onClick: onStartCheckout} = usePurchaseStartCallback(id || '', namespace || '');
	const emitEvent = useEmitEventOnClick({...props.analytics!, eventAction: 'checkout'});

	const onClick = <T extends Element>(e: SyntheticEvent<T>) => {
		emitEvent(e, {
			status: 'initiate',
			offerId: id,
			sandboxId: namespace
		});
		onStartCheckout();
	};

	return (
		<Card
			{...props.cardProps}
			title={props.cardProps.title || ' '}
			variant="ghost"
			imageAspectRatio="3:4"
			imageMode="single"
			data-testid="use-checkout"
			onClick={onClick}
			onKeyDown={getOnKeyDownProp((e) => onClick(e))}
		/>
	);
};
